
export function QuotationSupplyNotes() {
  return <details className="border-t border-line pt-2 text-xs text-mut"><summary className="flex min-h-9 cursor-pointer items-center">Supply &amp; payment notes</summary><p className="mt-1 leading-relaxed">Delivery charges excluded. Each accepted agreement has one receipt confirmation and full payment release. Accepted agreements keep their original terms.</p></details>;
}
